import React from "react";
import { EvtHeader } from "components/header";
import { PermissionGate } from "permissions/components/gate";
import ErrorState from "@/components/states/error";
import TaskForm from "../form";

export default function CreateTask() {
  return (
    <PermissionGate
      rule="create:*"
      collection="tasks"
      fallback={
        <div className="flex-1">
          <ErrorState message="You don't have permission to create tasks." />
        </div>
      }
    >
      <div className="flex-1">
        <EvtHeader title="Create Task" />
        <div className="max-w-md p-4 lg:p-6">
          <TaskForm />
        </div>
      </div>
    </PermissionGate>
  );
}
